import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ReleaseQuery } from '../services/release.service';

@Component({
  selector: 'dcc-release-query',
  templateUrl: './release-query.component.html',
  styleUrls: ['./release-query.component.scss'],
})
export class ReleaseQueryComponent implements OnInit {
  @Output() updateQuery: EventEmitter<ReleaseQuery> =
    new EventEmitter<ReleaseQuery>();
  @Input() total: number;
  @Input() queryParams: ReleaseQuery;

  statusOptions: SelectableOption<string>[] = [
    { name: 'Deployed', value: 'Deployed', selected: true },
    { name: 'Disabled', value: 'Disabled', selected: false },
    { name: 'In Progress', value: 'InProgress', selected: true },
    { name: 'Pending', value: 'Pending', selected: true },
    { name: 'Pending Review', value: 'PendingReview', selected: true },
    { name: 'Rejected', value: 'Rejected', selected: true },
  ];
  statusOptionsSelected = this.getSelectedItems(this.statusOptions);

  appTypeOptions: SelectableOption<string>[] = [
    { name: 'Modular App', selected: true },
    { name: 'Firmware', selected: true },
  ];
  appTypeSelected = this.getSelectedItems(this.appTypeOptions);

  query: ReleaseQuery;

  constructor(private router: Router) {}

  ngOnInit(): void {
    if (this.queryParams) {
      this.query = this.queryParams;
      this.statusOptions = this.onSelectionChange(
        this.statusOptions.map((status) => {
          return {
            name: status.name,
            value: status.value,
            selected: false,
          };
        }),
        this.queryParams.status.map((status) => {
          return {
            name: this.getStatusName(status),
            value: status,
            selected: true,
          };
        }),
      );
      this.appTypeOptions = this.onSelectionChange(
        this.appTypeOptions,
        this.queryParams.appType.map((appType) => {
          return { name: appType, selected: true };
        }),
      );
      this.statusOptionsSelected = this.getSelectedItems(this.statusOptions);
      this.appTypeSelected = this.getSelectedItems(this.appTypeOptions);
    } else {
      this.query = {
        releaseName: '',
        releaseCreator: '',
        status: this.statusOptionsSelected,
        appType: this.appTypeSelected,
      };
    }

    this.emitReleaseQuery();
  }

  onReleaseNameEntered(item: string) {
    this.query.releaseName = item;
    this.emitReleaseQuery();
  }

  onReleaseOwnerEntered(item: string) {
    this.query.releaseCreator = item;
    this.emitReleaseQuery();
  }

  onStatusSelectionChange(selectedItems: SelectableOption<string>[]) {
    this.statusOptions = this.onSelectionChange(
      this.statusOptions,
      selectedItems,
    );
    this.query.status = this.getSelectedItems(this.statusOptions);
    this.emitReleaseQuery();
  }

  onAppSelectionChange(selectedAppOptions: SelectableOption<string>[]): void {
    this.appTypeOptions = this.onSelectionChange(
      this.appTypeOptions,
      selectedAppOptions,
    );
    this.query.appType = this.getSelectedItems(this.appTypeOptions);
    this.emitReleaseQuery();
  }

  onReset() {
    this.statusOptions.forEach((status) => {
      if (status.name === 'Disabled') {
        status.selected = false;
      }
      status.selected = true;
    });
    this.statusOptionsSelected = this.getSelectedItems(this.statusOptions);

    this.appTypeOptions.forEach((appType) => {
      appType.selected = true;
    });
    this.appTypeSelected = this.getSelectedItems(this.appTypeOptions);

    this.query = {
      releaseName: '',
      releaseCreator: '',
      status: this.statusOptionsSelected,
      appType: this.appTypeSelected,
    };

    this.emitReleaseQuery();
  }

  private emitReleaseQuery(): void {
    this.updateQuery.emit(this.query);
  }

  private onSelectionChange(
    options: SelectableOption<string>[],
    selected: SelectableOption<string>[],
  ): SelectableOption<string>[] {
    console.log(options, 'options', selected, 'selected');
    options.map((option) => {
      option.selected = selected.some(
        (selectedItem) =>
          (selectedItem.value ?? selectedItem.name) ===
          (option.value ?? option.name),
      );
    });
    return options;
  }

  private getSelectedItems(selected: SelectableOption<string>[]): string[] {
    return selected
      .filter((option) => option.selected)
      .map((option) => option.value ?? option.name);
  }

  private getStatusName(status: string): string {
    switch (status) {
      case 'InProgress':
        return 'In Progress';
      case 'PendingReview':
        return 'Pending Review';
      default:
        return status;
    }
  }
}

export interface SelectableOption<T> {
  name: string;
  value?: T;
  selected: boolean;
}
